import { createDate } from 'shared/utils/formatUTC';
import { Program } from '../../Reports/NewReportDialog';
import { ReportsForProgram } from './api';

const formatDate = (date: Date) => date.toISOString().split('T')[0];
export const adjustStartAndEndDates = (
  s: string | undefined,
  e: string | undefined,
  year: number,
): { startDate: string | undefined; endDate: string | undefined } => {
  const start = createDate(s);
  const end = createDate(e);
  if (!start || !end) return { startDate: undefined, endDate: undefined };
  const diff = end.getFullYear() - start.getFullYear();
  const newStart = new Date(start);
  newStart.setFullYear(year);
  const newEnd = new Date(end);
  newEnd.setFullYear(year + diff);
  return {
    startDate: formatDate(newStart),
    endDate: formatDate(newEnd),
  };
};

export const getReportIdForProgram = (
  reports: ReportsForProgram[],
  program: Program,
  y: number,
): ReportsForProgram | undefined => {
  const year = y.toString();
  return reports.find(r => r.programId === program.Id && r.year === year);
};
